import { handleActions } from 'redux-actions';

import SideBySideViewMode from 'models/api/side-by-side-view-mode-modal';
import {
  resetSideBySideViewMode,
  sideBySideViewModeAction,
} from 'store/actions/side-by-side-view-annotations-actions';
import {
  resetAutoTieoutStatusForBanner,
  setAutoTieoutStatusForBanner,
} from 'store/actions/auto-tieout/workpaper-details-action';

export default handleActions(
  {
    [sideBySideViewModeAction]: (sideBySideViewMode, { payload }) => {
      return sideBySideViewMode.setViewMode(payload);
    },
    [setAutoTieoutStatusForBanner]: (sideBySideViewMode, { payload }) => {
      return sideBySideViewMode.setAutoTieoutStatusForBanners(payload);
    },
    [resetAutoTieoutStatusForBanner]: (sideBySideViewMode) => {
      return sideBySideViewMode.setAutoTieoutStatusForBanners({ status: null });
    },
    [resetSideBySideViewMode]: () => {
      return new SideBySideViewMode();
    },
  },
  new SideBySideViewMode(),
);
